/**
 * AI 视频参与度标注 - 枚举常量（与后端 aiTag 字段对齐）
 *
 * 后端取值：
 * - 4  未使用AI（默认）
 * - 2  少量AI
 * - 3  大量AI
 * - 0  未确认
 * - 1  全部AI（暂未在前端使用）
 */

// 未使用 AI（默认）
export const AI_TAG_UNUSED = 4;
// 全部 AI
export const AI_TAG_ALL = 1;
// 少量 AI
export const AI_TAG_LITTLE = 2;
// 大量 AI
export const AI_TAG_HEAVY = 3;
// 未确认
export const AI_TAG_UNCONFIRMED = 0;

/** 可选档位配置（用于下拉菜单渲染，不含"未确认"——后端默认值，不作为用户可选项） */
export const AI_USAGE_OPTIONS = [
  {
    value: AI_TAG_UNUSED,
    label: '未使用AI',
    icon: 'el-icon-video-camera',
    desc: '视频完全由人工实拍/制作，未使用任何AI工具',
    sub: '纯人工素材',
  },
  {
    value: AI_TAG_ALL,
    label: '全部AI',
    icon: 'el-icon-cpu',
    desc: '视频完全由AI生成，无人工实拍内容',
    sub: '整条视频均为AI产出',
  },
  {
    value: AI_TAG_LITTLE,
    label: '少量AI',
    icon: 'el-icon-magic-stick',
    desc: 'AI累计少于成片1/3，或只作辅助镜头',
    sub: '60s成片通常少于20s',
  },
  {
    value: AI_TAG_HEAVY,
    label: '大量AI',
    icon: 'el-icon-star-off',
    desc: 'AI累计达到成片1/3以上，或承担主视觉/核心卖点',
    sub: '60s成片通常20s以上',
  },
];

/** value -> label 映射 */
export const AI_TAG_LABEL_MAP = {
  [AI_TAG_UNUSED]: '未使用AI',
  [AI_TAG_ALL]: '全部AI',
  [AI_TAG_LITTLE]: '少量AI',
  [AI_TAG_HEAVY]: '大量AI',
  [AI_TAG_UNCONFIRMED]: '未确认',
};

/**
 * 根据取值获取展示文案
 *
 * 优先使用前端枚举文案（保证 UI 一致），前端不认识的枚举值
 * （如后端新增档位）用接口返回的 ai_tag_desc 兜底
 *
 * @param {number|null} value - AI 标记值
 * @param {string} fallback - 兜底文案（通常为接口返回的 ai_tag_desc）
 * @returns {string}
 */
export function getAiTagLabel(value, fallback = '') {
  if (value === null || value === undefined) return '';
  return AI_TAG_LABEL_MAP[value] ?? fallback ?? '';
}

/**
 * 兼容转换：将旧版字符串枚举转为后端数字枚举
 * @param {string|number|null} val - 旧值或新值
 * @returns {number|null}
 */
export function normalizeAiTag(val) {
  if (val === null || val === undefined) return null;
  if (typeof val === 'number') return val;
  if (val === '') return null;
  const MAP = { ALL: AI_TAG_ALL, LITTLE: AI_TAG_LITTLE, HEAVY: AI_TAG_HEAVY, UNCONFIRMED: AI_TAG_UNCONFIRMED, UNUSED: AI_TAG_UNUSED };
  return MAP[val] ?? null;
}
